/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AgentPromptCreate,
  AgentPromptResponse,
  AgentPromptVersionResponse,
  HTTPValidationError,
  PromptTestRequest,
  PromptTestResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listPromptsApiAgentPromptsGetResponse200 = {
  data: AgentPromptResponse[];
  status: 200;
};

export type listPromptsApiAgentPromptsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listPromptsApiAgentPromptsGetResponseSuccess =
  listPromptsApiAgentPromptsGetResponse200 & {
    headers: Headers;
  };
export type listPromptsApiAgentPromptsGetResponseError =
  listPromptsApiAgentPromptsGetResponse422 & {
    headers: Headers;
  };

export type listPromptsApiAgentPromptsGetResponse =
  | listPromptsApiAgentPromptsGetResponseSuccess
  | listPromptsApiAgentPromptsGetResponseError;

export const getListPromptsApiAgentPromptsGetUrl = () => {
  return `/api/agent-prompts`;
};

/**
 * Every editable prompt with the body currently in force for this team.
 * @summary List Prompts
 */
export const listPromptsApiAgentPromptsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listPromptsApiAgentPromptsGetResponse> => {
  return orvalFetch<listPromptsApiAgentPromptsGetResponse>(
    getListPromptsApiAgentPromptsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPromptsApiAgentPromptsGetQueryKey = () => {
  return [`/api/agent-prompts`] as const;
};

export const getListPromptsApiAgentPromptsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromptsApiAgentPromptsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>
  > = ({ signal }) =>
    listPromptsApiAgentPromptsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPromptsApiAgentPromptsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>
>;
export type ListPromptsApiAgentPromptsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListPromptsApiAgentPromptsGet<
  TData = Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
          TError,
          Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPromptsApiAgentPromptsGet<
  TData = Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
          TError,
          Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPromptsApiAgentPromptsGet<
  TData = Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Prompts
 */

export function useListPromptsApiAgentPromptsGet<
  TData = Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPromptsApiAgentPromptsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPromptsApiAgentPromptsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listVersionsApiAgentPromptsKindVersionsGetResponse200 = {
  data: AgentPromptVersionResponse[];
  status: 200;
};

export type listVersionsApiAgentPromptsKindVersionsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listVersionsApiAgentPromptsKindVersionsGetResponseSuccess =
  listVersionsApiAgentPromptsKindVersionsGetResponse200 & {
    headers: Headers;
  };
export type listVersionsApiAgentPromptsKindVersionsGetResponseError =
  listVersionsApiAgentPromptsKindVersionsGetResponse422 & {
    headers: Headers;
  };

export type listVersionsApiAgentPromptsKindVersionsGetResponse =
  | listVersionsApiAgentPromptsKindVersionsGetResponseSuccess
  | listVersionsApiAgentPromptsKindVersionsGetResponseError;

export const getListVersionsApiAgentPromptsKindVersionsGetUrl = (
  kind: string,
) => {
  return `/api/agent-prompts/${kind}/versions`;
};

/**
 * This team's saved revisions for one prompt, newest first.
 * @summary List Versions
 */
export const listVersionsApiAgentPromptsKindVersionsGet = async (
  kind: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listVersionsApiAgentPromptsKindVersionsGetResponse> => {
  return orvalFetch<listVersionsApiAgentPromptsKindVersionsGetResponse>(
    getListVersionsApiAgentPromptsKindVersionsGetUrl(kind),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVersionsApiAgentPromptsKindVersionsGetQueryKey = (
  kind: string,
) => {
  return [`/api/agent-prompts/${kind}/versions`] as const;
};

export const getListVersionsApiAgentPromptsKindVersionsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  kind: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListVersionsApiAgentPromptsKindVersionsGetQueryKey(kind);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>
  > = ({ signal }) =>
    listVersionsApiAgentPromptsKindVersionsGet(kind, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: kind !== null && kind !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListVersionsApiAgentPromptsKindVersionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>
>;
export type ListVersionsApiAgentPromptsKindVersionsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListVersionsApiAgentPromptsKindVersionsGet<
  TData = Awaited<
    ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  kind: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVersionsApiAgentPromptsKindVersionsGet<
  TData = Awaited<
    ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  kind: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
          >,
          TError,
          Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVersionsApiAgentPromptsKindVersionsGet<
  TData = Awaited<
    ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  kind: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Versions
 */

export function useListVersionsApiAgentPromptsKindVersionsGet<
  TData = Awaited<
    ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  kind: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVersionsApiAgentPromptsKindVersionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListVersionsApiAgentPromptsKindVersionsGetQueryOptions(kind, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createVersionApiAgentPromptsKindVersionsPostResponse201 = {
  data: AgentPromptResponse;
  status: 201;
};

export type createVersionApiAgentPromptsKindVersionsPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createVersionApiAgentPromptsKindVersionsPostResponseSuccess =
  createVersionApiAgentPromptsKindVersionsPostResponse201 & {
    headers: Headers;
  };
export type createVersionApiAgentPromptsKindVersionsPostResponseError =
  createVersionApiAgentPromptsKindVersionsPostResponse422 & {
    headers: Headers;
  };

export type createVersionApiAgentPromptsKindVersionsPostResponse =
  | createVersionApiAgentPromptsKindVersionsPostResponseSuccess
  | createVersionApiAgentPromptsKindVersionsPostResponseError;

export const getCreateVersionApiAgentPromptsKindVersionsPostUrl = (
  kind: string,
) => {
  return `/api/agent-prompts/${kind}/versions`;
};

/**
 * Save an edited prompt as a new revision and make it live. The old
 * and new text go to the team's audit log in the same transaction.
 * @summary Create Version
 */
export const createVersionApiAgentPromptsKindVersionsPost = async (
  kind: string,
  agentPromptCreate: AgentPromptCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createVersionApiAgentPromptsKindVersionsPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createVersionApiAgentPromptsKindVersionsPostResponse>(
    getCreateVersionApiAgentPromptsKindVersionsPostUrl(kind),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(agentPromptCreate),
    },
  );
};

export const getCreateVersionApiAgentPromptsKindVersionsPostMutationKey = () =>
  ["createVersionApiAgentPromptsKindVersionsPost"] as const;

export const getCreateVersionApiAgentPromptsKindVersionsPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>,
    TError,
    CreateVersionApiAgentPromptsKindVersionsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>,
  TError,
  CreateVersionApiAgentPromptsKindVersionsPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getCreateVersionApiAgentPromptsKindVersionsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>,
    CreateVersionApiAgentPromptsKindVersionsPostMutationVariables
  > = (props) => {
    const { kind, data } = props ?? {};

    return createVersionApiAgentPromptsKindVersionsPost(
      kind,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVersionApiAgentPromptsKindVersionsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>
  >;
export type CreateVersionApiAgentPromptsKindVersionsPostMutationBody =
  AgentPromptCreate;
export type CreateVersionApiAgentPromptsKindVersionsPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateVersionApiAgentPromptsKindVersionsPostMutationVariables = {
  kind: string;
  data: AgentPromptCreate;
};

/**
 * @summary Create Version
 */
export const useCreateVersionApiAgentPromptsKindVersionsPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>,
      TError,
      CreateVersionApiAgentPromptsKindVersionsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createVersionApiAgentPromptsKindVersionsPost>>,
  TError,
  CreateVersionApiAgentPromptsKindVersionsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateVersionApiAgentPromptsKindVersionsPostMutationOptions(options),
    queryClient,
  );
};
export type activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse200 =
  {
    data: AgentPromptResponse;
    status: 200;
  };

export type activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse422 =
  {
    data: HTTPValidationError;
    status: 422;
  };

export type activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponseSuccess =
  activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse200 & {
    headers: Headers;
  };
export type activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponseError =
  activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse422 & {
    headers: Headers;
  };

export type activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse =

    | activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponseSuccess
    | activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponseError;

export const getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostUrl =
  (kind: string, version: number) => {
    return `/api/agent-prompts/${kind}/versions/${version}/activate`;
  };

/**
 * Roll back to an earlier revision without rewriting history. The
 * audit log keeps which version was live before and after.
 * @summary Activate Version
 */
export const activateVersionApiAgentPromptsKindVersionsVersionActivatePost =
  async (
    kind: string,
    version: number,
    options?: Parameters<typeof orvalFetch>[1],
  ): Promise<activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse> => {
    return orvalFetch<activateVersionApiAgentPromptsKindVersionsVersionActivatePostResponse>(
      getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostUrl(
        kind,
        version,
      ),
      {
        ...options,
        method: "POST",
      },
    );
  };

export const getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationKey =
  () =>
    ["activateVersionApiAgentPromptsKindVersionsVersionActivatePost"] as const;

export const getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
        >
      >,
      TError,
      ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
      >
    >,
    TError,
    ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
        >
      >,
      ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables
    > = (props) => {
      const { kind, version } = props ?? {};

      return activateVersionApiAgentPromptsKindVersionsVersionActivatePost(
        kind,
        version,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
      >
    >
  >;

export type ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationError =
  ErrorType<HTTPValidationError>;
export type ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables =
  { kind: string; version: number };

/**
 * @summary Activate Version
 */
export const useActivateVersionApiAgentPromptsKindVersionsVersionActivatePost =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
          >
        >,
        TError,
        ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof orvalFetch>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof activateVersionApiAgentPromptsKindVersionsVersionActivatePost
      >
    >,
    TError,
    ActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationVariables,
    TContext
  > => {
    return useMutation(
      getActivateVersionApiAgentPromptsKindVersionsVersionActivatePostMutationOptions(
        options,
      ),
      queryClient,
    );
  };
export type testPromptApiAgentPromptsKindTestPostResponse200 = {
  data: PromptTestResponse;
  status: 200;
};

export type testPromptApiAgentPromptsKindTestPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type testPromptApiAgentPromptsKindTestPostResponseSuccess =
  testPromptApiAgentPromptsKindTestPostResponse200 & {
    headers: Headers;
  };
export type testPromptApiAgentPromptsKindTestPostResponseError =
  testPromptApiAgentPromptsKindTestPostResponse422 & {
    headers: Headers;
  };

export type testPromptApiAgentPromptsKindTestPostResponse =
  | testPromptApiAgentPromptsKindTestPostResponseSuccess
  | testPromptApiAgentPromptsKindTestPostResponseError;

export const getTestPromptApiAgentPromptsKindTestPostUrl = (kind: string) => {
  return `/api/agent-prompts/${kind}/test`;
};

/**
 * Run a candidate prompt against one real trajectory. Writes nothing.
 * @summary Test Prompt
 */
export const testPromptApiAgentPromptsKindTestPost = async (
  kind: string,
  promptTestRequest: PromptTestRequest,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<testPromptApiAgentPromptsKindTestPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<testPromptApiAgentPromptsKindTestPostResponse>(
    getTestPromptApiAgentPromptsKindTestPostUrl(kind),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(promptTestRequest),
    },
  );
};

export const getTestPromptApiAgentPromptsKindTestPostMutationKey = () =>
  ["testPromptApiAgentPromptsKindTestPost"] as const;

export const getTestPromptApiAgentPromptsKindTestPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>,
    TError,
    TestPromptApiAgentPromptsKindTestPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>,
  TError,
  TestPromptApiAgentPromptsKindTestPostMutationVariables,
  TContext
> => {
  const mutationKey = getTestPromptApiAgentPromptsKindTestPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>,
    TestPromptApiAgentPromptsKindTestPostMutationVariables
  > = (props) => {
    const { kind, data } = props ?? {};

    return testPromptApiAgentPromptsKindTestPost(kind, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestPromptApiAgentPromptsKindTestPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>
>;
export type TestPromptApiAgentPromptsKindTestPostMutationBody =
  PromptTestRequest;
export type TestPromptApiAgentPromptsKindTestPostMutationError =
  ErrorType<HTTPValidationError>;
export type TestPromptApiAgentPromptsKindTestPostMutationVariables = {
  kind: string;
  data: PromptTestRequest;
};

/**
 * @summary Test Prompt
 */
export const useTestPromptApiAgentPromptsKindTestPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>,
      TError,
      TestPromptApiAgentPromptsKindTestPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof testPromptApiAgentPromptsKindTestPost>>,
  TError,
  TestPromptApiAgentPromptsKindTestPostMutationVariables,
  TContext
> => {
  return useMutation(
    getTestPromptApiAgentPromptsKindTestPostMutationOptions(options),
    queryClient,
  );
};
